export default async function sha256(str: string | undefined) {
    if (!str) {
        return undefined;
    }
    const mail = new TextEncoder().encode(str);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', mail);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

    return hashHex;
}
